import { BrowserPrintUnavailableError } from "./errors";
import type { BrowserPrintApi, WindowLike } from "./types";

interface GlobalLike {
  window?: WindowLike;
  BrowserPrint?: BrowserPrintApi;
}

function resolveWindowLike(windowLike?: WindowLike): WindowLike | undefined {
  if (windowLike !== undefined) {
    return windowLike;
  }

  const globalLike = globalThis as unknown as GlobalLike;
  if (globalLike.window !== undefined) {
    return globalLike.window;
  }

  if (globalLike.BrowserPrint !== undefined) {
    return { BrowserPrint: globalLike.BrowserPrint };
  }

  return undefined;
}

export function isBrowserPrintAvailable(windowLike?: WindowLike): boolean {
  const resolved = resolveWindowLike(windowLike);
  return resolved?.BrowserPrint !== undefined;
}

export function getBrowserPrintApi(windowLike?: WindowLike): BrowserPrintApi {
  const resolved = resolveWindowLike(windowLike);
  if (resolved?.BrowserPrint !== undefined) {
    return resolved.BrowserPrint;
  }

  throw new BrowserPrintUnavailableError();
}
